import { redirect } from 'redux-first-router';
import type { Options } from 'redux-first-router';
import queryString from 'query-string';
import { hasAccessTokenSelector } from '@/redux/auth/selectors';
import { ROUTE_WELCOME } from '@/constants/routes';

import { isAuthenticationNeeded } from './utils';

export const getRouterOptions = (options: Options): Options => {
  return {
    onBeforeChange: (dispatch, getState, { action }) => {
      const hasAccessToken = hasAccessTokenSelector(getState());
      const needsAuthentication = isAuthenticationNeeded(action.type);
      if (needsAuthentication && !hasAccessToken) {
        return dispatch(redirect({ type: ROUTE_WELCOME }));
      }
    },
    querySerializer: queryString,
    ...options,
  };
};
